import React from "react";
import {DataInitialState, DataState} from "./data.reducer";

export const DataContext = React.createContext<{
    state: DataState;
    dispatch: React.Dispatch<any>;
}>({state: DataInitialState, dispatch: () => null});
